import { render, staticRenderFns } from "./LeaveRecordListAddNew.vue?vue&type=template&id=61a373d6&"
import script from "./LeaveRecordListAddNew.vue?vue&type=script&lang=js&"
export * from "./LeaveRecordListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRecordListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports